import React from 'react';
import './InstitutionsPage.css';

const InstitutionsPage = () => {
  return (
    <div className="institutions-page">
      {/* Hero Section */}
      <section className="inst-hero">
        <div className="container">
          <div className="inst-hero-grid">
            <div className="inst-hero-illustration-left">
              <img
                src="/Institution_banner_left.png"
                alt="Connected system with dashboards, charts and data visualization"
                className="inst-illustration-img"
              />
            </div>

            <div className="inst-hero-content">
              <h1 className="inst-hero-title">
                An Integrated Career Intelligence Platform for Class 11 & 12 Institutions
              </h1>
              <p className="inst-hero-subtitle">
                Enable your institution to offer structured, accurate, and data-driven career guidance across all streams — under your own brand.
              </p>
              <div className="inst-hero-cta">
                <button className="btn btn-teal">Request Institutional Demo</button>
                <button className="btn btn-orange">Partner With 12thPlus</button>
              </div>
            </div>

            <div className="inst-hero-illustration-right">
              <img
                src="/Institution_banner_right.png"
                alt="Career pathway roadmap with compass and milestones"
                className="inst-illustration-img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* The Institutional Challenge */}
      <section className="section inst-challenge-section">
        <div className="container">
          <h2 className="section-title">THE INSTITUTIONAL CHALLENGE</h2>

          <div className="challenge-grid">
            <div className="challenge-card">
              <div className="challenge-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
              </div>
              <h3>Reactive Guidance</h3>
              <p>Guidance is often unstructured and reactive to student queries.</p>
            </div>

            <div className="challenge-card">
              <div className="challenge-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="11" cy="11" r="8" />
                  <path d="M21 21l-4.35-4.35" />
                  <path d="M11 8v6M8 11h6" />
                </svg>
              </div>
              <h3>Unverified Sources</h3>
              <p>Students rely on scattered, often inaccurate online information.</p>
            </div>

            <div className="challenge-card">
              <div className="challenge-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <h3>Parental Demand</h3>
              <p>Parents seek clarity on reliable outcomes and future pathways.</p>
            </div>

            <div className="challenge-card">
              <div className="challenge-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <rect x="3" y="3" width="7" height="7" />
                  <rect x="14" y="3" width="7" height="7" />
                  <rect x="14" y="14" width="7" height="7" />
                  <rect x="3" y="14" width="7" height="7" />
                </svg>
              </div>
              <h3>Lack of Centralized Tools</h3>
              <p>Faculty lack a unified platform to manage career data effectively.</p>
            </div>
          </div>
        </div>
      </section>

      {/* What 12thPlus Enables */}
      <section className="section inst-enables-section">
        <div className="container">
          <h2 className="section-title">WHAT 12THPLUS ENABLES FOR INSTITUTIONS</h2>

          <div className="enables-grid">
            <div className="enables-feature left">
              <h3>Centralized Intelligence System</h3>
              <p>A single source for career & admissions data across all streams.</p>
            </div>

            <div className="enables-feature left">
              <h3>Comprehensive Stream Coverage</h3>
              <p>Includes Engineering, Medical, Commerce, Law, Arts, Architecture, and more.</p>
            </div>

            <div className="enables-mockup">
              <div className="mockup-window-inst">
                <div className="mockup-header-inst">
                  <div className="mockup-dots-inst">
                    <span></span><span></span><span></span>
                  </div>
                </div>
                <div className="mockup-body-inst">
                  <div className="mockup-sidebar-inst"></div>
                  <div className="mockup-content-inst">
                    <div className="mockup-chart-inst"></div>
                    <div className="mockup-cards-inst">
                      <div></div><div></div><div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="enables-feature right">
              <h3>Pathway Predictors & Timelines</h3>
              <p>Data-driven tools for cut-offs, quotas, fees, and application deadlines.</p>
            </div>

            <div className="enables-feature right">
              <h3>Institution-Controlled Communication</h3>
              <p>Manage and approve all student-facing updates and guidance.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Comprehensive Stream Coverage */}
      <section className="section stream-coverage-section">
        <div className="container">
          <div className="stream-coverage-grid">
            <div className="stream-coverage-left">
              <h2 className="section-title-left">COMPREHENSIVE STREAM COVERAGE</h2>

              <div className="stream-cards-grid">
                <div className="stream-card-inst">
                  <div className="stream-icon-inst blue">⚙️</div>
                  <span>Engineering</span>
                </div>
                <div className="stream-card-inst">
                  <div className="stream-icon-inst red">🏥</div>
                  <span>Medical & Dental</span>
                </div>
                <div className="stream-card-inst">
                  <div className="stream-icon-inst orange">💼</div>
                  <span>Commerce & Management</span>
                </div>
                <div className="stream-card-inst">
                  <div className="stream-icon-inst purple">⚖️</div>
                  <span>Law</span>
                </div>
                <div className="stream-card-inst">
                  <div className="stream-icon-inst pink">🎨</div>
                  <span>Arts & Liberal Studies</span>
                </div>
                <div className="stream-card-inst">
                  <div className="stream-icon-inst teal">🏛️</div>
                  <span>Architecture</span>
                </div>
              </div>

              <div className="benefit-cards">
                <div className="benefit-card">
                  <div className="benefit-icon">📍</div>
                  <span>Clear Post-12th Pathways</span>
                </div>
                <div className="benefit-card">
                  <div className="benefit-icon">🎯</div>
                  <span>Reduced Confusion & Misinformation</span>
                </div>
                <div className="benefit-card">
                  <div className="benefit-icon">📊</div>
                  <span>Equal Access to Information</span>
                </div>
              </div>

              <p className="includes-note">INCLUDES INDIA & STUDY ABROAD PATHWAYS</p>
            </div>

            <div className="stream-coverage-right">
              <div className="brand-infrastructure">
                <h2>YOUR BRAND, OUR INFRASTRUCTURE</h2>

                <div className="brand-features">
                  <div className="brand-feature">
                    <span className="brand-check">✓</span>
                    <div>
                      <h4>Fully Branded Experience</h4>
                      <p>The platform operates under your institution's name and branding.</p>
                    </div>
                  </div>

                  <div className="brand-feature">
                    <span className="brand-check">✓</span>
                    <div>
                      <h4>Custom Login URL</h4>
                      <p>Students access the portal through a dedicated institutional link.</p>
                    </div>
                  </div>

                  <div className="brand-feature">
                    <span className="brand-check">✓</span>
                    <div>
                      <h4>Institution-Owned Student Journey</h4>
                      <p>You control the entire guidance experience, reinforcing your brand's value.</p>
                    </div>
                  </div>
                </div>

                <div className="brand-mockup">
                  <div className="brand-mockup-inner">
                    <span className="brand-label">Dayui text login</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Data Integrity & Trust */}
      <section className="inst-trust-section">
        <div className="container">
          <h2 className="trust-section-title">DATA INTEGRITY & TRUST</h2>

          <div className="trust-grid-inst">
            <div className="trust-card-inst">
              <div className="trust-icon-inst">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </div>
              <h3>Institution-Owned Data</h3>
              <p>Student data remains your property, secure and private.</p>
            </div>

            <div className="trust-card-inst">
              <div className="trust-icon-inst">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </div>
              <h3>No Third-Party Marketing</h3>
              <p>We never share data for external marketing purposes.</p>
            </div>

            <div className="trust-card-inst">
              <div className="trust-icon-inst">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <path d="M9 15l2 2 4-4" />
                </svg>
              </div>
              <h3>Compliant Infrastructure</h3>
              <p>Built on secure, governance-friendly architecture.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Strategic Advantages & Backed by Expertise */}
      <section className="section advantages-section">
        <div className="container">
          <div className="advantages-grid">
            <div className="advantages-left">
              <h2>STRATEGIC ADVANTAGES</h2>

              <div className="advantage-items">
                <div className="advantage-item">
                  <span className="advantage-check">✓</span>
                  <div>
                    <h4>Enhances Academic Value</h4>
                    <p>Strengthens your institution's overall educational offering.</p>
                  </div>
                </div>

                <div className="advantage-item">
                  <span className="advantage-check">✓</span>
                  <div>
                    <h4>Strengthens Parent Trust</h4>
                    <p>Builds long-term confidence among parents.</p>
                  </div>
                </div>

                <div className="advantage-item">
                  <span className="advantage-check">✓</span>
                  <div>
                    <h4>Differentiate Your Institution</h4>
                    <p>Stands out by providing superior career support.</p>
                  </div>
                </div>

                <div className="advantage-item">
                  <span className="advantage-check">✓</span>
                  <div>
                    <h4>Scalable Across Batches</h4>
                    <p>Easily deploys for all Class 11 & 12 students year after year.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="advantages-right">
              <h2>BACKED BY EXPERTISE</h2>

              <div className="expertise-items">
                <div className="expertise-item">
                  <div className="expertise-icon">🏆</div>
                  <span>Years of Counselling Expertise</span>
                </div>

                <div className="expertise-item">
                  <div className="expertise-icon">🎓</div>
                  <span>Students Guided</span>
                </div>

                <div className="expertise-item">
                  <div className="expertise-icon">🤝</div>
                  <span>Institutional Partnerships</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="inst-cta-section">
        <div className="container">
          <h2>READY TO EMPOWER YOUR INSTITUTION?</h2>
          <div className="inst-cta-buttons">
            <button className="btn btn-teal btn-lg">SCHEDULE AN INSTITUTIONAL DEMO</button>
            <button className="btn btn-orange btn-lg">DISCUSS PARTNERSHIP</button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InstitutionsPage;
